import React from 'react';

import styles from './SimpleFinancialTableRow.module.scss';

type Props = {
  type: string;
  value: string;
};

const SimpleFinancialTableRow = ({ type, value }: Props) => (
  <div className={styles.simpleRow}>
    <div className={styles.type}>{type}</div>
    <div className={styles.value}>{value}</div>
  </div>
);

export default SimpleFinancialTableRow;
